import { Component } from "@angular/core";

@Component({
  selector: "kpr-demo-practice-report",
  templateUrl: "./demo-practice-report.component.html",
  styleUrls: [],
})
export class DemoPracticeReportComponent {}
